import { render, staticRenderFns } from "./CommercialIcon.vue?vue&type=template&id=2eb2b31f&"
import script from "./CommercialIcon.vue?vue&type=script&lang=js&"
export * from "./CommercialIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports